import $ from 'jquery';

export default class SelectToggle {
    init() {
        $(document).ready(() => { this.setup(); });
    }
    setup() {
        let me = this;
        me.initSelectToggle();
    }

    initSelectToggle() {
        $(".toggle-class").on('click', function() {
            $(this).toggleClass("expanded");
        });

        $(document).on('change', '.toggle-selector', function(){
            $(this).parent().find('.toggle-options').hide();
            $(this).parent().find('.' + $(this).val()).show();
        });
    };
}



